import { GroupId } from "@custom-types/base-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

export type StateCreateNewTeam = {
  isLoading: boolean;
  selectedGroupId?: GroupId;
  teamName: string;
  description: string;
  selectedRole?: FaroCoreApiTypes.AssignmentRoleBySubjectType["company"];
};

export type ActionCreateNewTeam =
  | { type: "SET_IS_LOADING"; isLoading: boolean }
  | {
      type: "SET_SELECTED_GROUP_ID";
      selectedGroupId: GroupId | undefined;
    }
  | { type: "SET_TEAM_NAME"; teamName: string }
  | { type: "SET_DESCRIPTION"; description: string }
  | {
      type: "SET_SELECTED_ROLE";
      selectedRole:
        FaroCoreApiTypes.AssignmentRoleBySubjectType["company"] | undefined;
    };

export function reducerTeams(
  state: StateCreateNewTeam,
  action: ActionCreateNewTeam
): StateCreateNewTeam {
  switch (action.type) {
    case "SET_IS_LOADING":
      return { ...state, isLoading: action.isLoading };
    case "SET_SELECTED_GROUP_ID":
      return { ...state, selectedGroupId: action.selectedGroupId };
    case "SET_TEAM_NAME":
      return { ...state, teamName: action.teamName };
    case "SET_DESCRIPTION":
      return { ...state, description: action.description };
    case "SET_SELECTED_ROLE":
      return { ...state, selectedRole: action.selectedRole };
    default:
      return state;
  }
}
